import productMutations from './mutations.js';
import productActions from './actions.js';
import productGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            products: [],
            categories: [],
            format_category: [],
            industrial_category: [],

            interchange_sku: '',
            interchange_manufacturers: [],

            whi_smart_url: '',
            whi_product: {},

            custom_attrs: [],
            filter_attr:  [],
        }
    },
    mutations: productMutations,
    actions: productActions,
    getters: productGetters
};
